import { Component, Input, OnInit } from '@angular/core';
import { WidgetBaseComponent } from '../../widgetBase';

/**
 * Wraps a widget value and applies formatting to it
 */
@Component({
  selector: 'widget-value',
  templateUrl: './widget-value.component.html',
  styleUrls: ['./widget-value.component.scss']
})
export class WidgetValueComponent implements OnInit {
  /**
   * Apply a special color?
   */
  @Input() color: string;

  /**
   * Align: left, center, right
   */
  @Input() align: string;

  /**
   * Bold?
   */
  @Input() bold: boolean;

  /**
   * Italic?
   */
  @Input() italic: boolean;

  /**
   * The field name
   */
  @Input() fieldName: string;

  /**
   * The widget
   */
  @Input() widget: WidgetBaseComponent;

  /**
   * Special negative number formatting?
   */
  @Input() negativeNumberFormatting = false;

  /**
 * Flag if hashtags are supported
 */
  @Input() supportHashtag = false;

  /**
   * List of css classes
   */
  classes: string[] = [];

  /**
   * Initializes the component
   */
  ngOnInit() {
    if (this.align) {
      this.classes.push('align-' + this.align);
    }

    if (this.bold) {
      this.classes.push('bold');
    }

    if (this.italic) {
      this.classes.push('italic');
    }

    if (this.color) {
      this.classes.push('color-' + this.color);
    }
    else {
      this.classes.push('color-dark-gray');
    }
  }
}
